import { useEffect, useRef } from "react";

const SCRIPT_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

export default function TurnstileWidget({ siteKey, onTokenChange, resetSignal, action = "signup" }) {
  const container = useRef(null);
  const widgetId = useRef(null);
  const callback = useRef(onTokenChange);
  callback.current = onTokenChange;

  useEffect(() => {
    if (!siteKey) return undefined;
    let active = true;
    let script = document.querySelector(`script[src="${SCRIPT_URL}"]`);
    const render = () => {
      if (!active || !container.current || !window.turnstile || widgetId.current !== null) return;
      widgetId.current = window.turnstile.render(container.current, {
        sitekey: siteKey,
        action,
        callback: (token) => callback.current(token),
        "expired-callback": () => callback.current(""),
        "error-callback": () => callback.current(""),
      });
    };
    if (!script) {
      script = document.createElement("script");
      script.src = SCRIPT_URL;
      script.async = true;
      document.head.appendChild(script);
    }
    script.addEventListener("load", render);
    render();
    return () => {
      active = false;
      script.removeEventListener("load", render);
      if (widgetId.current !== null && window.turnstile) {
        window.turnstile.remove(widgetId.current);
        widgetId.current = null;
      }
    };
  }, [siteKey, action]);

  useEffect(() => {
    if (resetSignal && widgetId.current !== null) window.turnstile?.reset(widgetId.current);
  }, [resetSignal]);

  return <div ref={container} aria-label="Security check" />;
}
